import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import useTranslation from '../../../../Hooks/useTranslation';
import PatientConsentModalContent from './PatientConsentModalContent';
import { PatientConsentType } from '../../Commands/WritePatientConsent';
import { Size } from '../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	consentType: PatientConsentType;
}

const PatientConsentModal: React.FC<Props> = props => {
	const { opened, onClose, patientIdentifier, consentType } = props;

	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			size={Size.SM}
			wrapChat={isCase}>
			<Modal.Header title='nczi.patientPresenceConfirmation.title' firstUpper />
			<Modal.Content>
				<PatientConsentModalContent
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					consentType={consentType}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default PatientConsentModal;
